import * as React from "react";
import {useState} from "react";
import cx from "classnames";
import Section from "../Layout/Section";
import TemplateString from "../Common/TemplateString";
import Arrow from "../../assets/svg/arrow.svg";
import * as styles from "./faq.module.css";

const Faq = ({items}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <Section title="Часто задаваемые вопросы">
            {items.map(({id, question, answer}, idx) => {
                return (
                    <div key={id} className={cx(styles.faq__item, {[styles.faq__item_active]: activeIndex === idx})}>
                        <button
                            type="button"
                            onClick={() => setActiveIndex(idx)}
                            className={styles.faq__itemButton}
                            aria-label={`Открыть ответ на вопрос ${question}`}
                        />
                        <h3 className={styles.faq__itemTitle}>
                            <span>
                                <TemplateString template={question} />
                            </span>
                            <Arrow />
                        </h3>
                        <p className={styles.faq__itemAnswer}>
                            <TemplateString template={answer} />
                        </p>
                    </div>
                );
            })}
        </Section>
    );
};

export default Faq;
